
import { Grid, Container } from '@mui/material';
import DblChevronRight from '../dashboard/assets/dbl-chevron-right.svg';
import { incidentCardConfig } from './utils/incidentCardConfig';
import {
  incidentsCardContainer,
  incidentsCardCard,
  incidentsCardCardContainer,
  heading,
  incidentsCardCardBody,
  margin,
  incidentsCardContainerColumn
} from './styles/incidentsCard';

const processCard = (item) => {
  return (
      <Grid container sx={incidentsCardCardContainer}>
        <Grid item xs={10} sx={heading}>{item.name}</Grid>
        <Grid item xs={2} textAlign={'right'} sx={margin('bottom', '5px')}>
          <img src={DblChevronRight} alt='chevron-right' />
        </Grid>
        {item.icon ? (
          <Grid item xs={2} sx={incidentsCardCardBody}>
            <img src={item.icon} alt='icon' style={margin('right', '5px')} />
            {item.count}
          </Grid>
        ) : (
          <Grid item xs={2} sx={incidentsCardCardBody}>
            {item.count}
          </Grid>
        )}
      </Grid>
  )
}

const IncidentsCard = () => {
  return (
    <Container sx={incidentsCardContainer}>
      <Container sx={incidentsCardContainerColumn}>
        {incidentCardConfig[0].map((item) => (
          <Container key={item.id} sx={incidentsCardCard}>
            {processCard(item)}
          </Container>
        ))}
      </Container>
      <Container sx={incidentsCardContainerColumn}>
        {incidentCardConfig[1].map((item) => (
          <Container key={item.id} sx={incidentsCardCard}>
            {processCard(item)}
          </Container>
        ))}
      </Container>
    </Container>
  )
}

export default IncidentsCard;